import { AdminService } from "../../core/services/AdminService";
import { Singleton } from "../../core/services/Singleton";
import { BasicPage } from "../theme/Component/BasicPage"
import { useEffect, useState } from 'react';
import { BasicTable } from "../theme/Component/BasicTable";
import { BasicButton } from '../theme/Component/BasicButton';
import { Modal } from '../theme/Component/Modal';
import { InputDate } from '../theme/Input/InputDate';
import { ModalConfirm } from "../theme/Component/ModalConfirm";
import { useDashboardStore } from "../pages/hooks/useDashboardStore";

export const Projects = () => {

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service: AdminService = new AdminService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const head = [
        { title: 'ID', property: 'IDSoftwareProject' },
        { title: 'Nombre', property: 'Name' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Fecha Inicial', property: 'InitDate' },
        { title: 'Fecha Final', property: 'EndingDate' }
    ]

    useEffect(() => {
        getSoftwareProjectCatalog();
    }, [])
    useEffect(() => {
        setModal({ ...modal, ['view']: false });
    }, [lista])

    const getSoftwareProjectCatalog = () => {

        setLoading(true);
        service.getSoftwareProjectCatalog().subscribe(
            (resp: any) => {
                setLista([]);
               //console.log("Application", resp);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        );

    }

    const agregarItem = () => {
        let b = {
            Name: '',
            Description: '',
            State: 1,
            InitDate: single.getCurrenDate(),
            EndingDate: single.getCurrenDate()
        }
        setBean(b);
        setModal({ ...modal, ['view']: true });

    }
    const editarItem = () => {

        setModal({ ...modal, ['view']: true });

    }
    const eliminarItem = () => {

        setLoading(true);
        service.deleteSoftwareProject(bean.IDSoftwareProject).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getSoftwareProjectCatalog();
                }
            }
        );
        setModalConfirm({ ...modalConfirm, ['view']: false });

    }
    const updateItem = () => {

        setModal({ ...modal, ['view']: false });
        setLoading(true);
        service.updateSoftwareProject(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getSoftwareProjectCatalog();
                }
            });

    }

    const setRowBean = (bean: any) => {
       //console.log("Row : ", bean);
        setBean(bean);

    }




    return (
        <>
            <BasicPage titulo="Administrador Proyectos">
                <div className="row">
                    <div className="col-md-12">
                        <BasicButton value="Agregar" icon="ri-file-add-line" eventClick={agregarItem} ></BasicButton>
                        {bean.IDSoftwareProject &&
                            <>
                                <BasicButton value="Editar" icon="ri-edit-2-line" eventClick={editarItem} ></BasicButton>
                                <BasicButton value="Eliminar" icon="ri-eraser-line" eventClick={() => { setModalConfirm({ ...modalConfirm, ['view']: true }); }} ></BasicButton>
                            </>
                        }

                    </div>
                    <div className="col-md-12 p-2">
                        <BasicTable head={head} body={lista} rowSet={setRowBean}></BasicTable>
                    </div>
                </div>
            </BasicPage>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm >

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-12">
                        <label className="form-label">Nombre</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, ['Name']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate label="Fecha Inicial" name="InitDate" value={bean.InitDate} setDate={(e: any) => { setBean({ ...bean, ['InitDate']: e }) }}></InputDate>

                    </div>
                    <div className="col-md-6">
                        <InputDate label="Fecha Inicial" name="EndingDate" value={bean.InitDate} setDate={(e: any) => { setBean({ ...bean, ['EndingDate']: e }) }}></InputDate>
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                    </div>

                </div>
            </Modal>
        </>
    )
}